import { RoleType } from '../types';

export function validateUser(data: Record<string, unknown>): string[] {
    const errors: string[] = [];

    if (!data.firstname) {
        errors.push('Prénom requis.');
    }

    if (!data.lastname) {
        errors.push('Nom requis.');
    }

    if (!data.phoneNumber) {
        errors.push('Tél requis.');
    }

    if (data.phoneNumber) {
        if (!(typeof data.phoneNumber === 'string'
            && data.phoneNumber.length >= 10 && /^0[1-9][0-9]{8,}$/.test(data.phoneNumber))) {
            errors.push('N° de téléphone invalide: au moins 10 chiffres et doit commencer par 0');
        }
    }

    if (!data.agencyId) {
        errors.push('Agence requise.');
    }

    // if (validationMode === ValidationMode.CREATE) {
    //     if (!data.password && data.role !== RoleType.SUBSCRIBER) {
    //         errors.push('Mot de passe requis.')
    //     }
    // }

    if (!data.role) {
        errors.push('Role requis.');
    }

    if (data.role && data.role !== RoleType.SUBSCRIBER) {
        if (!data.email) {
            errors.push('Email requis.');
        }
    }

    return errors;
}
